import React, { ChangeEvent, useState } from 'react';
import { Counter, Price } from 'fronton-react';
import { dimensionsAtom, TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { useRecoilState } from 'recoil';
import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { addNewCountValue } from 'common/helpers/add-new-count-value.helper';
import { PriceAndCounterBlock } from '../styles';

type TPriceAndCounterComponent = {
  product: TComplimentaryProductInfo;
};

export const PriceAndCounterComponent = ({ product }: TPriceAndCounterComponent) => {
  const [counter, setCounter] = useState<number>(
    product.total.requiredQuantity >= 1 ? product.total.requiredQuantity : 0
  );

  const [dimensionState, setDimensionState] = useRecoilState(dimensionsAtom);

  const isDisable = !getIsCheckedProducts({
    checkedProducts: dimensionState.checkedProducts,
    productId: product.productId,
  });

  const addCount = (e: ChangeEvent<HTMLInputElement>, value: string) => {
    setDimensionState(prevState => ({
      ...prevState,
      complimentaryProductInfo: addNewCountValue({ prevState, newValue: Number(value), product }),
    }));
    setCounter(Number(value));
  };

  const getTotalPrice = () => product?.salesPriceValueInConsumerUnitValue * counter;

  return (
    <PriceAndCounterBlock>
      <div>
        <Counter onChange={addCount} value={`${counter}`} size="s" disabled={isDisable} />
      </div>

      <div>
        <Price
          color={isDisable ? 'text-minor' : 'text-primary'}
          align="center"
          size="m"
          units="₽"
          value={getTotalPrice()}
          variant="medium"
        />
      </div>
    </PriceAndCounterBlock>
  );
};
